import { useGetLocationsQuery, useGetRegionsQuery } from 'gql/types';
import { useMemo } from 'react';

export type ReportFilterOptions = {
  regionNames: string[];
  locationNames: string[];
};

/**
 * DB-backed option lists shared by the report filter bars, so region/location
 * dropdowns are populated before a report is generated.
 */
export const useReportFilterOptions = (): ReportFilterOptions => {
  const regionsQuery = useGetRegionsQuery();
  const locationsQuery = useGetLocationsQuery({
    variables: { input: { take: 1000 } },
  });

  return useMemo(
    () => ({
      regionNames: (regionsQuery.data?.getRegions ?? [])
        .map(({ name }) => name)
        .sort((a, b) => a.localeCompare(b)),
      locationNames: (locationsQuery.data?.getLocations.data ?? [])
        .map(({ name }) => name)
        .sort((a, b) => a.localeCompare(b)),
    }),
    [regionsQuery.data, locationsQuery.data]
  );
};
